export const normaliseData = (types, data, maxItems) => {
    const mutel = { values: [], readOnly: false };
    for (let i = 0; i < types.length; i++) {
        mutel.values[i] = '';
    }
    const mutar = [...data];
    // Remove any extra elements
    for (let i = maxItems; mutar.length > maxItems; --i) {
        mutar.splice(i, 1);
    }
    for (let i = mutar.length; i < maxItems; i++) {
        mutar[i] = { ...mutel };
    }
    while (mutar.length < maxItems) {
        mutar.push(mutel);
    }
    return mutar;
};
